import dayjs from 'dayjs';

export const DEFAULT_CONTRACT_ENTITY_ID = null;

const toIntOrNull = (value) =>
  value === null || value === undefined || value === '' ? null : Math.round(Number(value));

const toNumberOrZero = (value) =>
  value === null || value === undefined || value === '' ? 0 : Number(value);

export const mapLoiDetailsToLetterOfIntentPayload = (loiDetails) => ({
  contract_entity: loiDetails?.contractor_entity_id ?? DEFAULT_CONTRACT_ENTITY_ID,
  authorised_activities_commencement_date: loiDetails?.commencement_date ?? null,
  authorised_expenditure: toIntOrNull(loiDetails?.authorised_expenditure),
  authorised_expenditure_in_words: loiDetails?.authorised_expenditure_words ?? '',
  expiry_date: loiDetails?.loi_expiry_date ?? null,
  authorised_activities: loiDetails?.authorised_activities ?? '',
  authorised_activities_programme: loiDetails?.authorised_activities_programme ?? '',
  authorised_expenditure_breakdown: (loiDetails?.authorised_expenditure_breakdown ?? []).map(
    (row) => ({
      description: row?.description ?? '',
      amount: toNumberOrZero(row?.amount),
      notes: row?.notes ?? '',
    }),
  ),
  agreed_subcontract_order_document: loiDetails?.contract_route ?? '',
  reason: loiDetails?.justification ?? '',
});

export const parseLoiExpenditureBreakdown = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};
const toDateOnly = (value) => {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
};

export const mapTenderRecommendationToLoiDetails = (tenderData) => {
  if (!tenderData?.has_loi) return null;
  const source = tenderData.loi_details ?? tenderData;

  return {
    // Shown exactly as returned - no ID/label resolution attempted (out of
    // scope; no entity lookup table exists to resolve one anyway).
    contractor_entity: source.contract_entity ?? null,
    commencement_date: toDateOnly(source.authorised_activities_commencement_date),
    authorised_expenditure:
      source.authorised_expenditure === null || source.authorised_expenditure === undefined
        ? null
        : Number(source.authorised_expenditure),
    authorised_expenditure_words: source.authorised_expenditure_in_words ?? '',
    loi_expiry_date: toDateOnly(source.expiry_date),
    authorised_activities: source.authorised_activities ?? '',
    authorised_activities_programme: source.authorised_activities_programme ?? '',
    authorised_expenditure_breakdown: parseLoiExpenditureBreakdown(
      source.authorised_expenditure_breakdown,
    ),
    contract_route: source.agreed_subcontract_order_document ?? '',
    justification: source.reason ?? '',
  };
};
